import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { API_ENDPOINTS } from '../utils/api.constants';
import {
  CreateUserRequest,
  PaginatedResponse,
  TenantUser,
  UpdateUserRequest,
  UpdateUserServiceAssignmentRequest,
  UpsertUserServiceAssignmentRequest,
  UserServiceAssignment
} from '../models/tenant-user.model';

@Injectable({
  providedIn: 'root'
})
export class TenantUsersService {

  constructor(private http: HttpClient) { }

  getUsers(tenantUid?: string, page?: number): Observable<PaginatedResponse<TenantUser>> {
    let params = new HttpParams();
    if (tenantUid) {
      params = params.set('tenant_uid', tenantUid);
    }
    if (page) {
      params = params.set('page', page);
    }
    return this.http.get<PaginatedResponse<TenantUser>>(API_ENDPOINTS.USERS.LIST_WITH_SERVICES, { params });
  }

  createUser(payload: CreateUserRequest): Observable<unknown> {
    return this.http.post(API_ENDPOINTS.USERS.CREATE, payload);
  }

  updateUser(username: string, payload: UpdateUserRequest): Observable<unknown> {
    return this.http.patch(API_ENDPOINTS.USERS.DETAIL(username), payload);
  }

  deleteUser(username: string): Observable<void> {
    return this.http.delete<void>(API_ENDPOINTS.USERS.DETAIL(username));
  }

  createServiceAssignment(payload: UpsertUserServiceAssignmentRequest): Observable<UserServiceAssignment> {
    return this.http.post<UserServiceAssignment>(API_ENDPOINTS.USER_SERVICE_MANAGEMENT.LIST, payload);
  }

  updateServiceAssignment(id: number, payload: UpdateUserServiceAssignmentRequest): Observable<UserServiceAssignment> {
    return this.http.patch<UserServiceAssignment>(API_ENDPOINTS.USER_SERVICE_MANAGEMENT.DETAIL(id), payload);
  }

  deleteServiceAssignment(id: number): Observable<void> {
    return this.http.delete<void>(API_ENDPOINTS.USER_SERVICE_MANAGEMENT.DETAIL(id));
  }
}
